import { Box, Input, InputGroup, InputLeftElement } from "@chakra-ui/react"
import { SearchIcon } from "@chakra-ui/icons"
import { useEffect, useState } from "react"
import { PurchaseInformation } from "../commons/snap-purchaseInformation"
import { Tabs } from "../tabs"
import { ProductDocumentationTable } from "./product-info.sub.documentationTable"

const tabs = ["Documentation", "Purchase Information"]

export const ProductInfoTable = (): JSX.Element => {
  const [clickedTabIndex, setClickedTabIndex] = useState<number>(0)
  const [searchQuery, setSearchQuery] = useState<string>("")

  useEffect(() => {
    if (clickedTabIndex !== 0) {
      setSearchQuery("")
    }
  }, [clickedTabIndex])

  const isDocTab = clickedTabIndex === 0

  return (
    <>
      <Box pos="relative">
        <Tabs
          tabs={tabs}
          defaultTabIndex={0}
          tabClickHandler={(tabType, tabIndex) => {
            setClickedTabIndex(tabIndex)
          }}
          tabContainerStyles={isDocTab ? { pr: ["0", "0", "0", "220px"] } : undefined}
        />
        {isDocTab && (
          <Box
            pos="absolute"
            right="0"
            bottom="8px"
            display={["none", "none", "none", "flex"]}
            alignItems="center"
          >
            <InputGroup size="sm" maxW="200px">
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" boxSize="12px" />
              </InputLeftElement>
              <Input
                placeholder="Search page..."
                value={searchQuery}
                onChange={e => { setSearchQuery(e.target.value) }}
                borderRadius="4px"
                fontSize="13px"
                bg="white"
              />
            </InputGroup>
          </Box>
        )}
      </Box>
      {isDocTab && (
        <Box mb="12px" display={["flex", "flex", "flex", "none"]}>
          <InputGroup size="sm" maxW="200px">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.400" boxSize="12px" />
            </InputLeftElement>
            <Input
              placeholder="Search page..."
              value={searchQuery}
              onChange={e => { setSearchQuery(e.target.value) }}
              borderRadius="4px"
              fontSize="13px"
              bg="white"
            />
          </InputGroup>
        </Box>
      )}
      {clickedTabIndex === 0 && <ProductDocumentationTable searchQuery={searchQuery} />}
      {clickedTabIndex === 1 && <PurchaseInformation />}
    </>
  )
}
